import {avaiableLanguage} from "../util_const"

const availableLanguageMixin = {
    methods: {
        getAvaiableLanguage() {
            const arr_avaiableLanguage = avaiableLanguage.map((l)=>{
                return {
                    text: this.$vuetify.t(`$vuetify.languages.${l}`),
                    value: l

                }
            })
            return arr_avaiableLanguage
        },
    }
}

export default availableLanguageMixin